import AccountsReceivableSettlement from 'models/accounts-receivable-settlement'
import CurrencyMinxins from "common/mixins/currency";
export default {
  mixins: [CurrencyMinxins],
  data() {
    return {
      storageFeetableTitle: [
        { prop: 'settlementDate', label: '结算日期' },
        { prop: 'billHeadName', label: '抬头名称/抬头编码' },
        { prop: 'agentBusinessVal', label: '代收代付' },
        { prop: 'currencyVal', label: '币制' },
        { prop: 'amount', label: '金额' }
      ],
      storageTableData: [],
      // 存储费用单所有数据
      storageCodeList: [],
      storageCheckAll: false,
      // 选中的数据
      checkedStorageCodeList: [],
      // 选中展示高亮数据
      checkedHignStorageCodeList: [],
      storageIsIndeterminate: false,
      activeStorageCode: '',
      storageMonth: null,
      timer: null
    }
  },
  created() {
  },
  beforeDestroy () {
    if (this.timer) clearTimeout(this.timer);
  },
  methods: {
    // 存储费用列表
    initStorageFeeTable() {
      let projectId = this.screen.projectId;
      let balanceMonth = this.storageMonth;
      let currency = this.screen.currencySystem;
      let data = {
        projectId,
        balanceMonth,
        currency
      }
      AccountsReceivableSettlement.getStorageFeeList(data).then(res => {
        if (res.success) {
          let storageCodeList = [];
          res.result.map(value => {
            let obj = {};
            obj.code = value.inboundOrderNo;
            obj.batchStockId = value.batchStockId;
            obj.totalCharge = value.amount;
            obj.inboundDate = value.inboundDate;
            obj.agentBusiness = value.agentBusiness;
            obj.agentBusinessVal = value.agentBusiness ? '是' : '否';
            obj.billHeadId = value.billHeadId;
            obj.billHeadName = value.billHead ? `${value.billHead.name} ${value.billHead.code}` : '';
            obj.currency = value.currency;
            obj.subjectList = []
            let obj2 = {}
            obj2.settlementDate = `${value.settlementPeriodStart}至${value.settlementPeriodEnd}`;
            obj2.agentBusiness = value.agentBusiness;
            obj2.agentBusinessVal = value.agentBusiness ? '是' : '否';
            obj2.billHeadId = value.billHeadId;
            obj2.billHeadName = value.billHead ? `${value.billHead.name} ${value.billHead.code}` : '';
            obj2.currency = value.currency;
            obj2.currencyVal = this.currencySystemObj[value.currency];
            obj2.amount = value.amount;
            obj2.amountStrLength = value.amount.toString().length;
            obj.subjectList.push(obj2)
            storageCodeList.push(obj);
          });
          this.storageCodeList = storageCodeList
          this.storageIsIndeterminate = false;
          this.storageTableData = []
          this.checkedStorageCodeList = []
          this.checkedHignStorageCodeList = []
          this.initTotalAccountsReceivable()
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 初始化存储数据
    initStorageData() {
      this.storageTableData = []
      this.storageCodeList = []
      this.storageCheckAll = false
      this.checkedStorageCodeList = []
      this.checkedHignStorageCodeList = []
      this.storageIsIndeterminate = false
      this.activeStorageCode = ''
      this.storageMonth = null
    },
    changeMonth() {
      this.initStorageFeeTable()
    },
    // 单击存储费用单的数据
    onActiveStorageCode(row) {
      this.activeStorageCode = row.code
      this.timer = setTimeout(() => {
        this.storageTableData = (this.checkedHignStorageCodeList.indexOf(row.code) === -1)?[]:row.subjectList
      },100)
    },
    // 存储费用单全选
    handleStorageCheckAllChange(val) {
      let arr = []
      if (val) {
        this.storageCodeList.map(i => {
          arr.push(i.code)
        })
      }
      this.checkedHignStorageCodeList = arr
      this.checkedStorageCodeList = val ? this.storageCodeList : [];
      this.storageIsIndeterminate = false;
      this.initTotalAccountsReceivable()
    },
    handleCheckedStorageCodeChange(value) {
      let checkedCount = value.length;
      this.storageCheckAll = checkedCount === this.storageCodeList.length;
      this.storageIsIndeterminate = checkedCount > 0 && checkedCount < this.storageCodeList.length;
      this.initCheckedStorageCodeList()
    },
    /** 
     * @description 获取选中的存储费用单数据
    */
    initCheckedStorageCodeList() {
      let checkedStorageCodeList = []
      this.checkedHignStorageCodeList.map(i => {
        let obj = this.storageCodeList.find((item) => { return item.code === i })
        checkedStorageCodeList.push(obj)
      })
      this.checkedStorageCodeList = checkedStorageCodeList
      this.initTotalAccountsReceivable()
    },
  }
}